<script setup lang="ts">
import { BarChart } from '@/components/ui/chart-bar'
import { Card } from '@/components/ui/card'
import { computed, onMounted, ref } from 'vue'
import type { KpiRepartitionsChiffreAffaireCombinedListViewModel } from '@/lib/types'
import KpiChiffreDaffairesRepository from '@/repository/KpiChiffreDaffairesRepository'
import { formatCurrency } from '@/lib/format'

const repartitionData = ref<KpiRepartitionsChiffreAffaireCombinedListViewModel[]>([])

const filteredData = computed(() => {
  if (!repartitionData.value) return []

  return repartitionData.value.map((item) => ({
    agence_title: item.agence_title,
    'Chiffre d\'affaire prévisionnel': item.chiffre_affaire_previsionnel,
    'Chiffre d\'affaire réalisé': item.chiffre_affaire_realise
  }))
})

const formatCell = (field: string, value:  number) => {
  if (["Chiffre d'affaire prévisionnel", "Chiffre d'affaire réalisé"].includes(field)) {
    return formatCurrency(value)
  }
  return value
}

onMounted(async () => {
  repartitionData.value = await KpiChiffreDaffairesRepository.getRepartitionData()
})
</script>

<template>
  <Card
    title="Répartition chiffre d'afffaire par agence"
    :download-chart="{
      selector: '#chart-container',
      filename: 'kpi-chiffre-affaires.png',
    }"
  >
    <BarChart
      id="chart-container"
      :data="filteredData"
      index="agence_title"
      :categories="['Chiffre d\'affaire prévisionnel', 'Chiffre d\'affaire réalisé']"
      :format-cell="formatCell"
    />
  </Card>
</template>
